export const isZero = (amount: string): boolean => {
  return /^0*$/.test(amount);
};
